import { Routes, Route } from "react-router-dom";
import StoreBankAccount from "@/pages/financial/store-bank-account";

export default function StoreBankAccountRoutes() {
  return (
    <Routes>
      <Route path="/" element={<StoreBankAccount />} />
    </Routes>
  );
}
